export const getEditUserTriggerId = () => `editUserTrigger`;
